import { Type } from '@sinclair/typebox';
import { AssetTypes } from '../../enums/AssetTypes';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { createdResponse } from '../../routes/defaultResponses';

export const equipmentAssetPaths = {
    '/api/equipmentAsset': {
        post: {
            operationId: 'equipmentAssetControllers.create',
            responses: {
                ...createdResponse,
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            data: Type.Object({
                                file: Type.Object({
                                    size: Type.Number(),
                                    name: Type.String(),
                                    type: Type.String(),
                                    path: Type.Optional(Type.String()),
                                    s3Id: Type.Optional(Type.String()),
                                    width: Type.Optional(Type.Number()),
                                    height: Type.Optional(Type.Number()),
                                }),
                            }),
                        }),
                    },
                },
            },
            parameters: [
                { name: 'equipmentId', in: 'query', schema: Type.String(), required: true },
                { name: 'type', in: 'query', schema: Type.String() },
            ],
        },
        get: {
            operationId: 'equipmentAssetControllers.getAll',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    description: Type.String(),
                                    id: Type.String(),
                                    date: Type.String(),
                                    name: Type.String(),
                                    filenameThumbnail: Type.String(),
                                    filenameMidSize: Type.String(),
                                    fileExtension: Type.String(),
                                    size: Type.Number(),
                                    type: Type.Enum(AssetTypes),
                                }),
                            ),
                        },
                    },
                },
            },
            parameters: [{ name: 'equipmentId', in: 'query', schema: Type.String(), required: true }],
        },
    },
    '/api/equipmentAsset/{equipmentAssetId}': {
        parameters: [createPathGuidParameter('equipmentAssetId')],
        post: {
            operationId: 'equipmentAssetControllers.update',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                name: Type.String(),
                            }),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Object({
                            name: Type.String(),
                        }),
                    },
                },
            },
        },
        delete: {
            operationId: 'equipmentAssetControllers.remove',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Object({
                                ok: Type.Boolean(),
                            }),
                        },
                    },
                },
            },
        },
    },
} as const;
